var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button",class:{
		['button-' + _vm.color]: true,
		noBorder: _vm.noBorder,
		icon: _vm.icon,
		hover: _vm.hover,
		active: _vm.active,
		disabled: _vm.disabled,
		loading: _vm.loading,
	},style:(_vm.inverted
			? {
					['text-align']: _vm.left ? 'left' : 'center',
					['border-color']: _vm.hover ? '#fff' : _vm.noBorder ? 'transparent' : '#fff',
					['background-color']: _vm.active || (!_vm.noBorder && _vm.hover) ? '#fff' : _vm.colorHex,
					color: _vm.active || (!_vm.noBorder && _vm.hover) ? _vm.colorHex : '#fff',
			  }
			: {
					['text-align']: _vm.left ? 'left' : 'center',
					['border-color']: _vm.hover ? _vm.colorHex : _vm.noBorder ? 'transparent' : _vm.colorHex,
					['background-color']: _vm.active || (!_vm.noBorder && _vm.hover) ? _vm.colorHex : 'transparent',
					color: _vm.active || (!_vm.noBorder && _vm.hover) ? '#fff' : _vm.colorHex,
			  }),attrs:{"href":_vm.href,"target":_vm.target ? _vm.target : '_self'},on:{"click":(e) => _vm.$emit('click', e),"mouseover":function($event){_vm.hover = true},"mouseout":function($event){_vm.hover = false}}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"loading-icon",attrs:{"indeterminate":"","color":_vm.colorHex}}):_vm._e(),(_vm.value && !_vm.loading)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}}):_vm._e(),(_vm.icon && !_vm.loading)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }